var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRedoSmallicon = function SvgRedoSmallicon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M11.87 4.732 9.621 2.485a.5.5 0 0 1 0-.707l.424-.424a.5.5 0 0 1 .707 0l3.613 3.612a.8.8 0 0 1 0 1.132L10.753 9.71a.5.5 0 0 1-.707 0l-.424-.425a.5.5 0 0 1 0-.707l2.247-2.247H5.817A3.217 3.217 0 0 0 2.6 9.55c0 1.77 1.458 3.217 3.241 3.217h.526a.5.5 0 0 1 .5.5v.6a.5.5 0 0 1-.5.5h-.526C3.187 14.366 1 12.216 1 9.548a4.817 4.817 0 0 1 4.817-4.816h6.052Z",
    clipRule: "evenodd"
  })));
};
export default SvgRedoSmallicon;